export default __webpack_public_path__ + "static/media/login-image-desktop.eb96381f.jpg";